import { AfterViewInit, Component, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { BaseViewerService } from "../../viewer-components/services/internal-services/viewer-services/base-viewer.service";
import { ViewerConstants } from "../../shared/model/viewer-constants";
import { Weather } from "../../shared/model/triage-constants";

@Component({
  selector: "vector-layer-popup",
  templateUrl: "./vector-layer-popup.component.html",
  styleUrls: ["./vector-layer-popup.component.scss"],
  standalone: false,
})
export class VectorLayerPopupComponent implements AfterViewInit, OnDestroy {
  subscriptions: Subscription[] = [];

  viewerService: BaseViewerService;

  data: any;

  weatherFeatures = [];

  triageFeatures = [];

  measurementSystemId: number;

  ngAfterViewInit() {
    this.subscriptions.push(
      this.viewerService.measurementSystemId$.subscribe((systemId) => {
        this.measurementSystemId = systemId;
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  loadComponent(): void {
    if (this.data.features) {
      this.data.features.forEach((feature) => {
        const peril = Weather.STYLES[feature.properties.peril];
        this.weatherFeatures.push({
          text: peril.text,
          units: peril.units,
          value: feature.properties[peril.feature],
        });
      });
    }
    if (this.data.featuresCollection && this.data.featuresCollection.features) {
      this.data.featuresCollection.features.forEach((feature) => {
        this.triageFeatures.push({
          id: feature.properties.uuid,
          shape: feature.properties.shape,
          material: feature.properties.material,
        });
      });
    }
  }

  getUnitsConversion(type: string): string {
    return this.viewerService.getMeasurementConversion(
      type,
      ViewerConstants.MEASUREMENT_SYSTEMS.IDS.IMPERIAL,
      this.measurementSystemId,
    );
  }

  showPropertyInfo(): boolean {
    return this.triageFeatures && this.triageFeatures.length === 1;
  }

  showWeatherInfo(): boolean {
    return this.weatherFeatures && this.weatherFeatures.length > 0;
  }

  showPopup(): boolean {
    return this.showPropertyInfo() || this.showWeatherInfo();
  }
}
